import type { SessionCoordinator, SessionEvent } from './authSession';

const EVENT_KEY = 'mini_erp_auth_event';

export function createBrowserCoordinator(): SessionCoordinator {
  return {
    async lock(work) {
      if (!navigator.locks) throw new Error('Secure browser session locking is unavailable');
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        return await navigator.locks.request('mini-erp-auth-cookie', {
          mode: 'exclusive', signal: controller.signal,
        }, async () => {
          window.clearTimeout(timeout);
          return work();
        });
      } finally { window.clearTimeout(timeout); }
    },
    publish(event) {
      // Only a non-secret invalidation marker crosses tabs. Tokens stay in memory.
      localStorage.setItem(EVENT_KEY, JSON.stringify({ event, nonce: crypto.randomUUID() }));
    },
    subscribe(listener) {
      const receive = (event: StorageEvent) => {
        if (event.key !== EVENT_KEY || !event.newValue) return;
        try {
          const value: { event: SessionEvent } = JSON.parse(event.newValue);
          if (value.event === 'invalidate' || value.event === 'signed-in') listener(value.event);
        } catch { /* Unrelated or malformed storage events do not authenticate a tab. */ }
      };
      window.addEventListener('storage', receive);
      return () => window.removeEventListener('storage', receive);
    },
  };
}
